exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".makeModelInfoCta__box___AC7CM {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px 24px;\n  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.05);\n  margin: 16px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px; }\n\n.makeModelInfoCta__title___uEkFA {\n  font-size: 18px;\n  font-weight: 600;\n  color: #262626; }\n\n.makeModelInfoCta__description___1Ske_ {\n  font-size: 14px;\n  color: #595959;\n  line-height: 1.5; }\n\n.makeModelInfoCta__cta___3B3Sd {\n  align-self: flex-start;\n  margin-top: 8px;\n  padding: 10px 18px;\n  background-image: linear-gradient(to right, #fe586f, #ff725b);\n  color: #fff;\n  border-radius: 4px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 14px;\n  transition: opacity 0.2s ease; }\n  .makeModelInfoCta__cta___3B3Sd:hover, .makeModelInfoCta__cta___3B3Sd:focus, .makeModelInfoCta__cta___3B3Sd:active {\n    color: #fff;\n    opacity: 0.9;\n    text-decoration: none; }\n", ""]);

// exports
exports.locals = {
	"box": "makeModelInfoCta__box___AC7CM",
	"title": "makeModelInfoCta__title___uEkFA",
	"description": "makeModelInfoCta__description___1Ske_",
	"cta": "makeModelInfoCta__cta___3B3Sd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/MakeModelInfoCta/makeModelInfoCta.scss
// module id = 4563
// module chunks = 6